<template>
  <div class="vld-parent">
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :on-cancel="onCancel"
      :is-full-page="true"
      :color="loadingColor"
      :height="loadingHeight"
      :width="loadingWidth"
    ></loading>

    <div class="container-fluid mt-6" v-if="isLoading == false">
      <div class="col-12 text-right">
        <base-button
          v-if="isRevisor"
          size="sm"
          type="primary"
          @click="toggleEditMode"
          class="ml-2"
        >
          {{ editMode ? "Cancelar edición" : "Editar equipo" }}
        </base-button>
        <base-button
          v-if="isRevisor && editMode"
          size="sm"
          type="success"
          @click="saveChanges"
          class="ml-2"
        >
          Guardar cambios
        </base-button>
        <base-button
          v-if="!editMode"
          size="sm"
          type="neutral"
          @click="revision()"
          class="ml-2"
        >
          Solicitar revisión
        </base-button>
        <base-button
          @click="goBack"
          type="button"
          class="btn btn-sm btn-primary ml-2"
          >Volver</base-button
        >
      </div>

      <div class="row align-items-center">
        <div class="col-xl-12">
          <!-- CARD DATOS BÁSICOS -->
          <card>
            <div
              class="h3 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Datos básicos
            </div>
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-lg-3">
                  <img
                    v-if="asset.modelo.imagen"
                    :src="asset.modelo.imagen.url"
                    style="width: 100%"
                  />

                  <img
                    v-else
                    src="https://misepis-name-images.s3.eu-west-1.amazonaws.com/logo_home_d5aa3a5d49.png"
                    style="width: 100%"
                  />
                </div>

                <div class="col-lg-9">
                  <div style="margin-bottom: 20px">
                    <span
                      class="badge badge-lg"
                      style="
                        color: white;
                        background-color: gray;
                        margin-right: 4px;
                      "
                      variant="success"
                      v-if="asset.retirado"
                      >EQUIPO RETIRADO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="
                        color: white;
                        background-color: black;
                        margin-right: 4px;
                      "
                      v-if="asset.fin_vida_util_alcanzada"
                      >Fin vida útil</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: red"
                      variant="success"
                      v-if="incidenciasActivas.length > 0"
                      >EQUIPO CON INCIDENCIA</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: red"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'no_apto'
                      "
                      >NO APTO PARA SU USO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: green"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'apto' &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 60
                      "
                      >APTO PARA SU USO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: green"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'apto_a_vigilar' &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 60
                      "
                      >APTO A VIGILAR</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: orange"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'apto' &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 0
                      "
                      >APTO CADUCA PRONTO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: orange"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length > 0 &&
                        asset.revisiones[asset.revisiones.length - 1].estado ===
                          'apto_a_vigilar' &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 0
                      "
                      >APTO A VIGILAR CADUCA PRONTO</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: blue"
                      variant="success"
                      v-else-if="
                        asset.revisiones.length === 0 &&
                        moment(asset.fecha_prox_revision).diff(
                          moment(),
                          'days'
                        ) > 0
                      "
                      >PRÓXIMA REVISIÓN
                      {{ moment(asset.fecha_prox_revision).fromNow() }}</span
                    >
                    <span
                      class="badge badge-lg"
                      style="color: white; background-color: red"
                      variant="success"
                      v-else
                      >REVISIÓN CADUCADA
                      {{ moment(asset.fecha_prox_revision).fromNow() }}</span
                    >
                  </div>
                  <div class="row align-items-center">
                    <div class="col">
                      <span>Subtipo</span>
                      <h3 class="mb-0" v-if="asset.modelo">
                        {{ asset.modelo.subtipo.nombre }}
                      </h3>
                    </div>
                    <div class="col">
                      <span>Modelo</span>
                      <h3 class="mb-0">
                        {{ asset.modelo.nombre }}
                      </h3>
                    </div>
                    <div class="col">
                      <span>Fabricante</span>
                      <h3 class="mb-0">
                        {{ asset.modelo.fabricante.nombre }}
                      </h3>
                    </div>
                  </div>
                  <div class="row align-items-center" style="margin-top: 20px">
                    <div class="col">
                      <span>Número de serie</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{ asset.numero_serie }}
                      </h3>
                      <base-input
                        v-else
                        v-model="editedAsset.numero_serie"
                        placeholder="Número de serie"
                      />
                    </div>
                    <div class="col">
                      <span>Número de QR</span>
                      <h3
                        class="mb-0"
                        v-if="!editMode && asset.numero_serie.length > 4"
                      >
                        {{ asset.numero_serie_qr }}
                      </h3>
                      <base-input
                        v-else-if="editMode"
                        v-model="editedAsset.numero_serie_qr"
                        placeholder="Número de QR"
                      />
                      <h3 class="mb-0" v-else>No tiene QR asignado</h3>
                    </div>
                    <div class="col">
                      <span>Normativa</span>
                      <h3 class="mb-0">
                        {{ asset.modelo.normativa.nombre }}
                      </h3>
                    </div>
                  </div>
                  <div class="row align-items-center" style="margin-top: 20px">
                    <div class="col">
                      <span>Fecha fabricación</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{
                          moment(asset.fecha_fabricacion).format("DD/MM/YYYY")
                        }}
                        ({{ moment(asset.fecha_fabricacion).fromNow() }})
                      </h3>
                      <div v-else>
                        <small class="text-muted d-block">
                          Fecha actual:
                          {{
                            moment(asset.fecha_fabricacion).format("DD/MM/YYYY")
                          }}
                        </small>
                        <base-input
                          type="date"
                          v-model="editedAsset.fecha_fabricacion"
                          :placeholder="
                            moment(asset.fecha_fabricacion).format('YYYY-MM-DD')
                          "
                        />
                      </div>
                    </div>
                    <div class="col">
                      <span>Fecha Puesta en Servicio</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{
                          moment(asset.fecha_adquisicion).format("DD/MM/YYYY")
                        }}
                        ({{ moment(asset.fecha_adquisicion).fromNow() }})
                      </h3>
                      <div v-else>
                        <small class="text-muted d-block">
                          Fecha actual:
                          {{
                            moment(asset.fecha_adquisicion).format("DD/MM/YYYY")
                          }}
                        </small>
                        <base-input
                          type="date"
                          v-model="editedAsset.fecha_adquisicion"
                          :placeholder="
                            moment(asset.fecha_adquisicion).format('YYYY-MM-DD')
                          "
                        />
                      </div>
                    </div>
                    <div class="col">
                      <span>Fecha fin vida útil</span>
                      <h3 class="mb-0">
                        <template v-if="asset.fecha_fin_vida_util">
                          {{
                            moment(asset.fecha_fin_vida_util).format("DD/MM/YYYY")
                          }}
                          ({{ moment(asset.fecha_fin_vida_util).fromNow() }})
                        </template>
                        <template v-else>—</template>
                      </h3>
                    </div>
                  </div>
                  <div
                    class="row align-items-center"
                    style="margin-top: 20px"
                    v-if="
                      (asset.instalador != null && asset.instalador != '') ||
                      editMode
                    "
                  >
                    <div class="col">
                      <span>Instalador</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{ asset.instalador }}
                      </h3>
                      <div v-else class="d-flex align-items-center">
                        <el-select
                          v-model="editedAsset.instalador"
                          filterable
                          placeholder="Selecciona un revisor"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="usuario in available_usuarios"
                            :key="usuario.id"
                            :label="usuario.nombre"
                            :value="usuario.nombre"
                          />
                        </el-select>
                        <button
                          v-if="editedAsset.instalador"
                          class="btn btn-link text-danger ml-2 p-0"
                          @click="editedAsset.instalador = ''"
                          title="Limpiar instalador"
                          style="font-size: 1.2rem"
                        >
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div
                    class="row align-items-center"
                    style="margin-top: 20px"
                    v-if="
                      (asset.descripcion != null && asset.descripcion != '') ||
                      editMode
                    "
                  >
                    <div class="col">
                      <span>Información adicional</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{ asset.descripcion }}
                      </h3>
                      <base-input
                        v-else
                        type="textarea"
                        rows="3"
                        v-model="editedAsset.descripcion"
                        placeholder="Añadir comentarios"
                      />
                    </div>
                  </div>
                  <div
                    class="row align-items-center"
                    style="margin-top: 20px"
                    v-if="
                      asset.revisiones.length > 0 &&
                      asset.revisiones[asset.revisiones.length - 1]
                        .observaciones != null &&
                      asset.revisiones[asset.revisiones.length - 1]
                        .observaciones != ''
                    "
                  >
                    <div class="col">
                      <span>Observaciones revisión</span>
                      <h3 class="mb-0">
                        {{
                          asset.revisiones[asset.revisiones.length - 1]
                            .observaciones
                        }}
                      </h3>
                    </div>
                  </div>
                  <div
                    class="row align-items-center"
                    style="margin-top: 20px"
                    v-if="
                      (asset.ubicacion != null && asset.ubicacion != '') ||
                      editMode
                    "
                  >
                    <div class="col">
                      <span>Ubicación</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{ asset.ubicacion }}
                      </h3>
                      <base-input
                        v-else
                        v-model="editedAsset.ubicacion"
                        placeholder="Ubicación del equipo"
                      />
                    </div>
                  </div>
                  <div
                    class="row align-items-center"
                    style="margin-top: 20px"
                    v-if="
                      (asset.longitud != null && asset.longitud != '') ||
                      editMode
                    "
                  >
                    <div class="col">
                      <span>Longitud</span>
                      <h3 class="mb-0" v-if="!editMode">
                        {{ asset.longitud }}
                      </h3>
                      <base-input
                        v-else
                        v-model="editedAsset.longitud"
                        placeholder="Longitud del equipo"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </card>
          <!-- CARD INCIDENCIA -->
          <card
            v-if="asset.incidencias.length > 0"
            class="border border-danger"
          >
            <div
              class="h2 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Incidencia
            </div>
            <div class="card-body pt-0">
              <div class="row">
                <div class="col-lg-12">
                  <!-- PRIMERA FILA -->
                  <div class="row align-items-center">
                    <!--PRIORIDAD -->
                    <div class="col">
                      <span>Prioridad</span>

                      <h3 class="mb-0">
                        <span
                          class="badge badge-default"
                          :style="[
                            asset.incidencias[0].prioridad == 'Alta'
                              ? { backgroundColor: 'red' }
                              : { backgroundColor: 'orange' },
                          ]"
                          >{{ asset.incidencias[0].prioridad }}</span
                        >
                      </h3>
                    </div>
                    <!-- ESTADO -->
                    <div class="col">
                      <span>Estado</span>

                      <h3 class="mb-0">
                        <span
                          class="badge badge-default"
                          :style="[
                            asset.incidencias[0].estado_incidencia.nombre ==
                            'Abierta'
                              ? { backgroundColor: 'info' }
                              : { backgroundColor: 'green' },
                          ]"
                          >{{
                            asset.incidencias[0].estado_incidencia.nombre ==
                            "Abierta"
                              ? "Inciencia Abierta"
                              : "Incidencia Cerrada"
                          }}</span
                        >
                      </h3>
                    </div>
                    <!-- TIPO -->
                    <div class="col">
                      <span>Tipo</span>
                      <h3 class="mb-0" style="text-transform: uppercase">
                        {{ asset.incidencias[0].tipo_incidencia.descripcion }}
                      </h3>
                    </div>
                  </div>
                  <!-- SEGUNDA FILA -->
                  <div class="row align-items-center" style="margin-top: 20px">
                    <!-- USUARIO -->
                    <div class="col">
                      <span>Creada por</span>

                      <h3 class="mb-0">
                        <!-- Avatar -->
                        <!--  <img
                          v-if="
                            asset.incidencias[0] &&
                            asset.incidencias[0]..usuario
                              ..imagen_perfil.url
                          "
                          :src="
                            asset.incidencias[0]..usuario
                              ..imagen_perfil.url
                          "
                          class="avatar rounded-circle"
                        />
                        <img
                          v-else
                          src="/img/placeholder.png"
                          class="avatar rounded-circle"
                        /> -->
                        <a
                          :href="
                            '/user-management/edit-user/' +
                            asset.incidencias[0].usuario.id
                          "
                          class="font-weight-bold"
                        >
                          <b>
                            {{
                              asset.usuario.nombre +
                              " " +
                              asset.usuario.apellidos
                            }}</b
                          ></a
                        >
                      </h3>
                    </div>
                    <!-- FECHA -->
                    <div class="col">
                      <span>Fecha de creación</span>
                      <h3 class="mb-0">
                        {{
                          moment(asset.incidencias[0].createdAt).format(
                            "DD/MM/YYYY HH:mm"
                          )
                        }}
                        ({{ moment(asset.incidencias[0].createdAt).fromNow() }})
                      </h3>
                    </div>
                    <!-- MOTIVO -->
                    <div class="col">
                      <span>Motivo de la incidencia</span>
                      <h3 class="mb-0">
                        {{
                          asset.incidencias[0].descripcion === ""
                            ? "El usuario no ha escrito el motivo"
                            : asset.incidencias[0].descripcion
                        }}
                      </h3>
                    </div>
                  </div>
                  <!-- TERCERA FILA -->
                  <div class="row" style="margin-top: 20px">
                    <!-- IMÁGENES DE LA INCIDENCIA -->
                    <div
                      class="col"
                      v-if="
                        this.asset.incidencias[0].incidence_documents != null
                      "
                    >
                      <span>Imágenes de la incidencia</span>
                      <div class="mb-0">
                        <img
                          v-for="image in this.asset.incidencias[0]
                            .incidence_documents"
                          :src="image.url"
                          v-bind:key="image.id"
                          style="
                            width: auto;
                            max-height: 200px;
                            margin-inline-end: 20px;
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <!-- CUARTA FILA -->
                  <div class="row align-items-center" style="margin-top: 20px">
                    <!-- DESCARGAR -->
                    <div class="col">
                      <span>Documentación</span>
                      <h3 class="mb-0">
                        <button
                          type="button"
                          class="btn-icon-clipboard"
                          style="width: auto"
                          @click="downloadFileUrl(asset.incidencias[0].pdf)"
                        >
                          <div>
                            <span class="btn-inner--icon"
                              ><i class="fas fa-download"></i
                            ></span>
                            <span style="font-size: medium; font-weight: 500"
                              >Descargar PDF de la incidencia</span
                            >
                          </div>
                        </button>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <router-link
              :to="
                '/incidencia-management/view-incidencia/' +
                asset.incidencias[0].id
              "
              class="dropdown-item text-center text-primary font-weight-bold py-3"
              >Ver incidencia</router-link
            >
          </card>
          <!--  Documentos instalación -->
          <card>
            <div class="h3 card-header border-0 text-primary">
              Documentos instalación
            </div>
            <div class="card-body pt-0">
              <div class="row col-lg-12 align-items-center">
                <!-- certificado_instalacion -->
                <div class="col">
                  <div v-if="!editMode">
                    <button
                      type="button"
                      class="btn-icon-clipboard"
                      @click="
                        downloadFileUrl(asset.certificado_instalacion?.url)
                      "
                    >
                      <div>
                        <span class="btn-inner--icon"
                          ><i class="fas fa-download"></i
                        ></span>
                        <span style="font-size: medium; font-weight: 500"
                          >Certificado de instalación</span
                        >
                      </div>
                    </button>
                  </div>
                  <div v-else class="document-upload-container">
                    <div v-if="asset.certificado_instalacion?.url" class="mb-2">
                      <button
                        type="button"
                        class="btn-icon-clipboard"
                        @click="
                          downloadFileUrl(asset.certificado_instalacion.url)
                        "
                      >
                        <div>
                          <span class="btn-inner--icon"
                            ><i class="fas fa-download"></i
                          ></span>
                          <span style="font-size: medium; font-weight: 500"
                            >Certificado de instalación</span
                          >
                        </div>
                      </button>
                      <button
                        class="btn btn-danger btn-sm ml-2"
                        @click="removeInstallDoc('certificado_instalacion')"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <base-button
                      v-else
                      size="sm"
                      type="primary"
                      @click="$refs.certInstInput.click()"
                    >
                      <i class="fas fa-upload"></i> Subir certificado
                    </base-button>
                    <input
                      ref="certInstInput"
                      type="file"
                      accept="application/pdf"
                      style="display: none"
                      @change="
                        handleInstallDocUpload(
                          $event,
                          'certificado_instalacion'
                        )
                      "
                    />
                  </div>
                </div>

                <!-- declaracion_conformidad -->
                <div class="col">
                  <div v-if="!editMode">
                    <button
                      type="button"
                      class="btn-icon-clipboard"
                      @click="
                        downloadFileUrl(asset.declaracion_conformidad?.url)
                      "
                    >
                      <div>
                        <span class="btn-inner--icon"
                          ><i class="fas fa-download"></i
                        ></span>
                        <span style="font-size: medium; font-weight: 500"
                          >DC Instalación</span
                        >
                      </div>
                    </button>
                  </div>
                  <div v-else class="document-upload-container">
                    <div v-if="asset.declaracion_conformidad?.url" class="mb-2">
                      <button
                        type="button"
                        class="btn-icon-clipboard"
                        @click="
                          downloadFileUrl(asset.declaracion_conformidad.url)
                        "
                      >
                        <div>
                          <span class="btn-inner--icon"
                            ><i class="fas fa-download"></i
                          ></span>
                          <span style="font-size: medium; font-weight: 500"
                            >DC Instalación</span
                          >
                        </div>
                      </button>
                      <button
                        class="btn btn-danger btn-sm ml-2"
                        @click="removeInstallDoc('declaracion_conformidad')"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <base-button
                      v-else
                      size="sm"
                      type="primary"
                      @click="$refs.dcInstInput.click()"
                    >
                      <i class="fas fa-upload"></i> Subir DC
                    </base-button>
                    <input
                      ref="dcInstInput"
                      type="file"
                      accept="application/pdf"
                      style="display: none"
                      @change="
                        handleInstallDocUpload(
                          $event,
                          'declaracion_conformidad'
                        )
                      "
                    />
                  </div>
                </div>

                <!-- nota_de_calculo -->
                <div class="col">
                  <div v-if="!editMode">
                    <button
                      type="button"
                      class="btn-icon-clipboard"
                      @click="downloadFileUrl(asset.nota_de_calculo?.url)"
                    >
                      <div>
                        <span class="btn-inner--icon"
                          ><i class="fas fa-download"></i
                        ></span>
                        <span style="font-size: medium; font-weight: 500"
                          >Nota de cálculo</span
                        >
                      </div>
                    </button>
                  </div>
                  <div v-else class="document-upload-container">
                    <div v-if="asset.nota_de_calculo?.url" class="mb-2">
                      <button
                        type="button"
                        class="btn-icon-clipboard"
                        @click="downloadFileUrl(asset.nota_de_calculo.url)"
                      >
                        <div>
                          <span class="btn-inner--icon"
                            ><i class="fas fa-download"></i
                          ></span>
                          <span style="font-size: medium; font-weight: 500"
                            >Nota de cálculo</span
                          >
                        </div>
                      </button>
                      <button
                        class="btn btn-danger btn-sm ml-2"
                        @click="removeInstallDoc('nota_de_calculo')"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <base-button
                      v-else
                      size="sm"
                      type="primary"
                      @click="$refs.notaCalcInput.click()"
                    >
                      <i class="fas fa-upload"></i> Subir nota
                    </base-button>
                    <input
                      ref="notaCalcInput"
                      type="file"
                      accept="application/pdf"
                      style="display: none"
                      @change="
                        handleInstallDocUpload($event, 'nota_de_calculo')
                      "
                    />
                  </div>
                </div>

                <!-- plano -->
                <div class="col">
                  <div v-if="!editMode">
                    <button
                      type="button"
                      class="btn-icon-clipboard"
                      @click="downloadFileUrl(asset.plano?.url)"
                    >
                      <div>
                        <span class="btn-inner--icon"
                          ><i class="fas fa-download"></i
                        ></span>
                        <span style="font-size: medium; font-weight: 500"
                          >Plano</span
                        >
                      </div>
                    </button>
                  </div>
                  <div v-else class="document-upload-container">
                    <div v-if="asset.plano?.url" class="mb-2">
                      <button
                        type="button"
                        class="btn-icon-clipboard"
                        @click="downloadFileUrl(asset.plano.url)"
                      >
                        <div>
                          <span class="btn-inner--icon"
                            ><i class="fas fa-download"></i
                          ></span>
                          <span style="font-size: medium; font-weight: 500"
                            >Plano</span
                          >
                        </div>
                      </button>
                      <button
                        class="btn btn-danger btn-sm ml-2"
                        @click="removeInstallDoc('plano')"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <base-button
                      v-else
                      size="sm"
                      type="primary"
                      @click="$refs.planoInput.click()"
                    >
                      <i class="fas fa-upload"></i> Subir plano
                    </base-button>
                    <input
                      ref="planoInput"
                      type="file"
                      accept="application/pdf,image/*"
                      style="display: none"
                      @change="handleInstallDocUpload($event, 'plano')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </card>
          <!-- REVISIÓN -->
          <card>
            <div
              class="h3 card-header border-0 pt-md-4 pb-0 pb-md-4 text-primary"
            >
              Certificado de revisión
            </div>

            <div class="card-body pt-0">
              <!--  TENGO REVISIONES HECHAS CON Misepis -->
              <div
                v-if="this.asset.revisiones.length > 0"
                class="row col-lg-12 align-items-center"
              >
                <div class="col">
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    @click="downloadFile()"
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-download"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >Certificado de revisión</span
                      >
                    </div>
                  </button>
                </div>
                <div class="col">
                  <span>Fecha última revisión</span>
                  <h3 class="mb-0">
                    {{
                      moment(asset.fecha_prox_revision)
                        .subtract(1, "years")
                        .format("DD/MM/YYYY")
                    }}
                  </h3>
                </div>
                <div class="col">
                  <span>Fecha próxima revisión</span>
                  <h3 class="mb-0">
                    {{ moment(asset.fecha_prox_revision).format("DD/MM/YYYY") }}
                    ({{ moment(asset.fecha_prox_revision).fromNow() }})
                  </h3>
                </div>
                <div class="col"></div>
              </div>
              <div class="row" v-else>
                <div class="col-lg-12">
                  <h4>Este equipo no tiene documentación de revisión.</h4>
                </div>
              </div>
            </div>
          </card>

          <!-- CARD IMÁGENES -->
          <card v-if="asset.imagenes_adicionales?.length > 0 || editMode">
            <div class="h3 card-header border-0 text-primary">
              Galería de Imágenes
            </div>
            <div class="card-body">
              <!-- Drag and drop zone when in edit mode -->
              <div
                v-if="editMode"
                class="dropzone mb-3"
                :class="{ 'dropzone-active': isDragging }"
                @dragenter.prevent="isDragging = true"
                @dragleave.prevent="isDragging = false"
                @dragover.prevent
                @drop.prevent="handleDrop"
              >
                <div class="dropzone-content">
                  <i class="fas fa-cloud-upload-alt fa-3x mb-2"></i>
                  <p>Arrastra y suelta imágenes aquí o</p>
                  <base-button
                    size="sm"
                    type="primary"
                    @click="$refs.imageInput.click()"
                  >
                    Selecciona archivos
                  </base-button>
                  <input
                    ref="imageInput"
                    type="file"
                    multiple
                    accept="image/*"
                    style="display: none"
                    @change="handleImageSelect"
                  />
                </div>
              </div>

              <!-- Image grid -->
              <div class="row">
                <div
                  v-for="(imagen, index) in displayedImages"
                  :key="imagen.id || index"
                  class="col-md-4 mb-3 position-relative"
                >
                  <img
                    :src="imagen.url || imagen.preview"
                    class="img-thumbnail"
                    alt="Imagen Adicional"
                    style="width: 100%; height: auto"
                  />
                  <button
                    v-if="editMode"
                    @click="removeImage(index)"
                    class="btn btn-danger btn-sm position-absolute"
                    style="top: 10px; right: 25px"
                  >
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </card>
          <!-- DOCUMENTACIÓN TÉCNICA -->
          <card>
            <div class="h3 card-header border-0 text-primary">
              Documentación técnica
            </div>
            <div class="card-body pt-0">
              <div class="row col-lg-12 align-items-center">
                <div class="col">
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    @click="downloadFileUrl(asset.modelo.ficha_tecnica.url)"
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-download"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >Ficha técnica</span
                      >
                    </div>
                  </button>
                </div>
                <div class="col">
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    @click="
                      downloadFileUrl(asset.modelo.declaracion_conformidad.url)
                    "
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-download"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >DC Genérica</span
                      >
                    </div>
                  </button>
                </div>

                <div
                  class="col"
                  v-if="
                    asset.modelo.subtipo.nombre ===
                    'PUNTO DE ANCLAJE TRANSPORTABLE'
                  "
                >
                  <button
                    type="button"
                    class="btn-icon-clipboard"
                    @click="downloadFileUrl(asset.certificado_instalacion.url)"
                  >
                    <div>
                      <span class="btn-inner--icon"
                        ><i class="fas fa-download"></i
                      ></span>
                      <span style="font-size: medium; font-weight: 500"
                        >Certificado de instalación</span
                      >
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </card>
          <!--  DOCUMENTACIÓN ADICIONAL -->
          <card>
            <div class="h3 card-header border-0 text-primary">
              Documentación adicional
              <div v-if="isRevisor && editMode" class="float-right">
                <base-button
                  size="sm"
                  type="neutral"
                  @click="openDocumentUpload"
                >
                  <i class="fas fa-plus"></i> Añadir documento
                </base-button>
                <input
                  ref="documentInput"
                  type="file"
                  style="display: none"
                  @change="handleDocumentUpload"
                />
              </div>
            </div>
            <div class="card-body pt-0">
              <div
                class="row"
                v-if="asset.doc_adicional && asset.doc_adicional.length > 0"
              >
                <div class="col-lg-12">
                  <h4
                    v-for="documento in asset.doc_adicional"
                    v-bind:key="documento.id"
                  >
                    <div class="row">
                      <div class="col-lg-4">
                        <button
                          type="button"
                          class="btn-icon-clipboard"
                          @click="downloadAdditionalFile(documento)"
                        >
                          <div>
                            <span class="btn-inner--icon"
                              ><i class="fas fa-download"></i
                            ></span>
                            <span style="font-size: medium; font-weight: 500">{{
                              documento.nombre
                            }}</span>
                          </div>
                        </button>
                      </div>
                      <div v-if="isRevisor && editMode" class="col-lg-2">
                        <base-button
                          size="sm"
                          type="danger"
                          @click="removeDocument(documento)"
                        >
                          <i class="fas fa-trash"></i> Eliminar
                        </base-button>
                      </div>
                    </div>
                  </h4>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-lg-12">
                  <h4>No hay documentos adicionales.</h4>
                </div>
              </div>
            </div>
          </card>
          <!--  HISTORIAL REVISIONES -->
          <card v-if="this.asset.revisiones.length > 0">
            <div class="h3 card-header border-0 text-primary">
              Historial de revisiones
            </div>
            <div class="card-body pt-0">
              <div v-if="this.asset.revisiones.length > 0" class="col-lg-12">
                <h4
                  v-for="revision in [...asset.revisiones].reverse()"
                  v-bind:key="revision.id"
                >
                  <div class="row">
                    <div class="col-lg-4">
                      <button
                        type="button"
                        class="btn-icon-clipboard"
                        @click="downloadFile(revision.id)"
                      >
                        <div>
                          <span class="btn-inner--icon"
                            ><i class="fas fa-download"></i
                          ></span>
                          <span style="font-size: medium; font-weight: 500"
                            >{{
                              moment(revision.fecha_revision).format(
                                "DD/MM/YYYY"
                              )
                            }}

                            ({{ revision.estado_revision.nombre }})</span
                          >
                        </div>
                      </button>
                    </div>
                  </div>
                </h4>
              </div>
              <div class="row" v-else>
                <div class="col-lg-12">
                  <h4>Este equipo no tiene documentación de revisión.</h4>
                </div>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
    <!-- DIALOG ASIGNACIÓN EQUIPOS -->
    <el-dialog
      title="Asignación de equipos"
      :visible.sync="this.dialogFormVisible"
      width="60%"
    >
      <div class="col-auto">
        <p>Selecciona el usuario al que quieres asignar este equipo:</p>
        <el-select
          style="width: 100%"
          size="large"
          name="usuario"
          v-model="usuarioSeleccionado"
          placeholder="Selecciona el usuario..."
          filterable
        >
          <el-option
            v-for="usuario in available_usuarios"
            :key="usuario.id"
            :value="usuario.id"
            :label="usuario.nombre"
          >
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisible = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button
          v-if="usuarioSeleccionado"
          @click="assignPost"
          type="primary"
          >Confirmar</base-button
        >
      </span>
    </el-dialog>
    <!-- DIALOG SOLICITUD REVISIÓN -->
    <el-dialog
      title="Solicitar revisión a Misepis"
      :visible.sync="dialogFormVisibleRev"
      width="60%"
    >
      <div class="col-auto">
        <p>
          Si aceptas se enviará una solicitud para realizar una revisión de este
          equipo.
        </p>
        <ul>
          <li>
            Identificador: <b>{{ this.asset.nombre }}</b
            >. Número de serie:
            <b>{{ this.asset.numero_serie }}</b>
          </li>
        </ul>
      </div>

      <span slot="footer" class="dialog-footer">
        <base-button @click="dialogFormVisibleRev = false" type="secondary"
          >Cancelar</base-button
        >

        <base-button @click="revisionPost" type="primary">Aceptar</base-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import {
  Dialog,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Select,
  Option,
  Button,
  Image,
  // Loading
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";

import formMixin from "@/mixins/form-mixin";
import moment from "moment";
import { cloneDeep } from "lodash";
import "moment/locale/es"; // without this line it didn't work
import axios from "axios";

moment.locale("es");

export default {
  layout: "DashboardLayout",
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Dialog.name]: Dialog,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Image.name]: Image,
  },
  mixins: [formMixin],

  data() {
    return {
      image: "",
      file: null,
      available_empresas: [],
      available_divisiones: [],
      available_tipos: [],
      available_subtipos: [],
      available_fabricantes: [],
      available_modelos: [],
      images_incidence: [],
      isLoading: false,
      loadingColor: "#7f1058",
      loadingBgColor: "#000",
      loadingHeight: 128,
      loadingWidth: 128,
      dialogFormVisible: false,
      dialogFormVisibleRev: false,
      available_usuarios: [],
      usuarioSeleccionado: null,
      asset: {
        type: "assets",
        nombre: null,
        numero_serie: null,
        division: {
          id: null,
        },
        tipo: {
          id: null,
        },
        subtipo: {
          id: null,
        },
        fabricante: {
          id: null,
        },
        modelo: {
          id: null,
        },
        empresa: {
          id: null,
        },
        fecha_adquisicion: null,
        fecha_fabricacion: null,
        fecha_prox_revision: null,
        fecha_fin_vida_util: null,
        imagen: null,
        retirado: false,
        fin_vida_util_alcanzada: false,
      },
      notificacion: {
        type: "notificaciones",
        descripcion: null,
        estado_notificacion: {
          id: 1, //pendiente de enviar
        },
        tipo_notificacion: {
          id: 3, //tipo: revision
        },
        usuario_origen: {
          id: null,
        },
        usuario_destino: {
          id: null,
        },
        empresa: {
          id: null,
        },
        activos: {},
      },
      editMode: false,
      editedAsset: {
        // Add any necessary properties for editing
      },
      isRevisor: false,
      isDragging: false,
      newImages: [], // Array to store new images to be uploaded
      imagesToDelete: [], // Array to store images to be deleted
      displayedImages: [], // Array to store both existing and new images
    };
  },
  computed: {
    incidenciasActivas() {
      if (!this.asset.incidencias || !Array.isArray(this.asset.incidencias)) {
        return [];
      }
      
      return this.asset.incidencias.filter(incidencia => {
        // Verificar si la incidencia tiene estado "Abierta" o está activa (no cerrada ni resuelta)
        // Manejar tanto formato deserializado como Strapi v4
        const estadoNombre = incidencia.estado_incidencia?.nombre || 
                            incidencia.estado_incidencia?.data?.attributes?.nombre ||
                            incidencia.attributes?.estado_incidencia?.data?.attributes?.nombre;
        
        if (!estadoNombre) {
          return false;
        }
        
        const estadoLower = estadoNombre.toLowerCase();
        // Solo considerar activas las incidencias que NO estén resueltas ni cerradas
        return estadoLower !== 'resuelta' && estadoLower !== 'cerrada';
      });
    },
  },
  created() {
    this.checkUserRole();
    this.get();
    this.getUsuarios();
  },

  watch: {},
  methods: {
    onCancel() {
      console.log("User cancelled the loader.");
    },

    async get() {
      this.isLoading = true;
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("activos/getDetails", id);
        this.asset = this.$store.getters["activos/activo"];
        // Initialize displayedImages with the asset's images
        this.displayedImages = [...(this.asset.imagenes_adicionales || [])];
        console.log("ASSET: ", this.asset);
        this.isLoading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, algo ha ido mal!! Por favor, refresca la página y vuelve a intentarlo.`,
        });
        console.log(error);
        this.setApiValidation(error.response.data.errors);
        this.isLoading = false;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    getRevisionCemexURL() {
      const numero_serie = this.asset.numero_serie;
      const numero_serie_parseado = numero_serie.replace(/\s/g, "+");
      const idEmpresa = this.asset.empresa.id;

      if (idEmpresa == 74) {
        return (
          "https://misepis-name-images.s3.eu-west-1.amazonaws.com/EQUIPOS_CEMEX/Rev_" +
          numero_serie_parseado +
          ".pdf"
        );
      } else {
        return null;
      }
    },
    downloadFile(revisionId) {
      if (revisionId) {
        window.open(
          `https://misepis-api.delfromsoftware.com/api/revision-download/${revisionId}`,
          "_blank"
        );
      } else {
        const lastRev = this.asset.revisiones.length;
        if (lastRev > 0) {
          const lastRevision = this.asset.revisiones[lastRev - 1];
          window.open(
            `https://misepis-api.delfromsoftware.com/api/revision-download/${lastRevision.id}`,
            "_blank"
          );
        } else {
          this.$notify({
            type: "danger",
            message: `El equipo no tiene documento de revisión`,
          });
        }
      }
    },

    downloadAdditionalFile(element) {
      const archivosArray = element.archivos;

      for (let index = 0; index < archivosArray.length; index++) {
        const archivo = archivosArray[index];
        const url_adicional = archivo.url;
        console.log(url_adicional);

        this.downloadFileUrl(url_adicional);
      }
    },

    downloadFileUrl(url) {
      if (url) {
        window.open(url, "_blank");
      } else {
        this.$notify({
          type: "danger",
          message: `El documento no está disponible para su descarga.`,
        });
      }
    },
    checkIdRevisor(id) {
      return this.available_usuarios.some(function (gfg) {
        return gfg.id === id;
      });
    },
    async getUsuarios() {
      try {
        await this.$store.dispatch("profile/me");
        let me = await this.$store.getters["profile/me"];
        this.notificacion.usuario_origen.id = me.id;
        var meEmpresas = [];
        me.empresas.forEach((element) => {
          meEmpresas.push(element.id);
        });

        this.$store.dispatch("users/listLight").then(() => {
          var usuarios = cloneDeep(this.$store.getters["users/dropdownLight"]);

          console.log("USUARIOS: ", usuarios);

          usuarios.forEach((element) => {
            element.empresas.forEach((empresa) => {
              if (meEmpresas.includes(empresa.id)) {
                if (this.available_usuarios.length == 0) {
                  this.available_usuarios.push(element);
                }

                if (!this.checkIdRevisor(element.id)) {
                  console.log("ENTRA");
                  this.available_usuarios.push(element);
                }
              }
            });
          });
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },
    assign() {
      this.dialogFormVisible = true;
    },
    revision() {
      this.dialogFormVisibleRev = true;
    },

    async assignPost() {
      var el = this.asset;
      el.usuario = this.usuarioSeleccionado;
      this.dialogFormVisible = false;
      await this.$store.dispatch("activos/update", el);
      this.dialogFormVisible = false;

      this.showSwal("success");
      this.$router.go(0);
    },
    async revisionPost() {
      var activo = this.asset;
      let html_activos =
        "<ul><li> Identificador: <b>" +
        activo.nombre +
        "</b>. Número de serie: <b>" +
        activo.numero_serie +
        "</b></li></ul>";

      this.notificacion.activos = html_activos;
      // this.notificacion.activos = this.multipleSelection;
      console.log("NOTIFICACIÓN:");
      console.log(this.notificacion);

      try {
        await this.$store.dispatch("notificaciones/add", this.notificacion);
        this.$notify({
          type: "success",
          message: "La solicitud se ha enviado correctamente.",
        });
        this.dialogFormVisibleRev = false;
        //this.$router.go(0);
      } catch (error) {
        console.log(error);
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },
    async desAssignPost() {
      //this.fullscreenLoading = true;

      var el = this.asset;
      el.usuario = null;
      await this.$store.dispatch("activos/update", el);

      this.dialogFormVisible = false;

      this.showSwal("success_devueltos");
    },

    showSwal(type) {
      if (type === "basic") {
        swal.fire({
          title: `Here's a message!`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-primary",
        });
      } else if (type === "info") {
        swal.fire({
          icon: "info",
          title: `Info`,
          text: `A few words about this sweet alert ...`,
          buttonsStyling: false,
          confirmButtonClass: "btn btn-info",
        });
      } else if (type === "success") {
        this.dialogFormVisible = false;
        //this.fullscreenLoading = false;
        swal
          .fire({
            title: `¡Equipo asignado con éxito!`,
            // text: 'Equipos entregados con éxito',
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "success_devueltos") {
        this.isLoading = false;
        swal
          .fire({
            title: `¡Equipo devuelto con éxito!`,
            text: "Este equipo queda disponible para asignarlo a otro usuario.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            this.$router.go(0);
          });
      } else if (type === "warning") {
        swal.fire({
          title: `Warning`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-warning",
          icon: "warning",
        });
      } else if (type === "question") {
        swal.fire({
          title: `Are you sure?`,
          text: "A few words about this sweet alert ...",
          buttonsStyling: false,
          confirmButtonClass: "btn btn-default",
          icon: "question",
        });
      }
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
      if (this.editMode) {
        this.editedAsset = { ...this.asset };
        this.displayedImages = [...(this.asset.imagenes_adicionales || [])];
        this.newImages = [];
        this.imagesToDelete = [];
      }
    },
    async saveChanges() {
      try {
        // First, upload any new images
        let uploadedImages = [];
        if (this.newImages.length > 0) {
          uploadedImages = await this.uploadImages();
        }

        // Create update data object
        const updateData = {
          id: this.editedAsset.id,
          numero_serie: this.editedAsset.numero_serie || "",
          numero_serie_qr: this.editedAsset.numero_serie_qr || "",
          fecha_fabricacion: this.editedAsset.fecha_fabricacion || null,
          fecha_adquisicion: this.editedAsset.fecha_adquisicion || null,
          descripcion: this.editedAsset.descripcion || "",
          ubicacion: this.editedAsset.ubicacion || "",
          longitud: this.editedAsset.longitud || "",
          instalador: this.editedAsset.instalador || "",
          modelo: this.editedAsset.modelo || this.asset.modelo,
          usuario: this.editedAsset.usuario || null,
          doc_adicional: this.editedAsset.doc_adicional || [],
          imagenes_adicionales: this.editedAsset.imagenes_adicionales || [],
        };

        // Remove deleted images
        if (this.imagesToDelete.length > 0) {
          updateData.imagenes_adicionales =
            updateData.imagenes_adicionales.filter(
              (img) => !this.imagesToDelete.includes(img.id)
            );
        }

        // Add new images
        if (uploadedImages.length > 0) {
          updateData.imagenes_adicionales = [
            ...updateData.imagenes_adicionales,
            ...uploadedImages,
          ];
        }

        await this.$store.dispatch("activos/update", updateData);

        this.editMode = false;
        this.newImages = [];
        this.imagesToDelete = [];

        this.$notify({
          type: "success",
          message: "Cambios guardados correctamente",
        });

        // Si se han añadido o eliminado imágenes, refrescar la página
        if (uploadedImages.length > 0 || this.imagesToDelete.length > 0) {
          this.$router.go(0);
        } else {
          // Si no hay cambios en imágenes, solo actualizar el estado local
          this.asset = {
            ...this.asset,
            ...updateData,
          };
          this.displayedImages = [...this.asset.imagenes_adicionales];
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al guardar los cambios",
        });
        console.error(error);
      }
    },
    async checkUserRole() {
      try {
        await this.$store.dispatch("profile/me");
        const profile = await this.$store.getters["profile/me"];

        // Verificar si el usuario pertenece a la empresa SALVADOR SEGURIDAD EN ALTURA (ID: 134)
        this.isRevisor = profile.empresas.some((empresa) => empresa.id === 134);

        console.log("Es revisor:", this.isRevisor);
      } catch (error) {
        console.error("Error checking user role:", error);
        this.isRevisor = false;
      }
    },
    openDocumentUpload() {
      this.$refs.documentInput.click();
    },

    async handleDocumentUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      try {
        const formData = new FormData();
        formData.append("files", file);

        // Subir el archivo usando axios directamente con la URL base
        const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
        const uploadResponse = await axios.post(`${baseUrl}/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (uploadResponse.data && uploadResponse.data.length > 0) {
          // Crear el nuevo documento adicional con la estructura correcta
          const newDoc = {
            nombre: file.name,
            archivos: uploadResponse.data,
          };

          // Inicializar el array si no existe
          if (!this.editedAsset.doc_adicional) {
            this.editedAsset.doc_adicional = [];
          }

          // Añadir el nuevo documento al array
          this.editedAsset.doc_adicional.push(newDoc);

          // Actualizar el activo en el servidor con el nuevo documento
          const updateData = {
            id: this.editedAsset.id,
            doc_adicional: this.editedAsset.doc_adicional,
          };

          await this.$store.dispatch("activos/update", updateData);
          this.asset = {
            ...this.asset,
            doc_adicional: this.editedAsset.doc_adicional,
          };

          this.$notify({
            type: "success",
            message: "Documento subido correctamente",
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al subir el documento",
        });
        console.error(error);
      }
    },

    async removeDocument(documento) {
      try {
        // Eliminar el documento del array local
        const index = this.editedAsset.doc_adicional.findIndex(
          (doc) => doc.nombre === documento.nombre
        );
        if (index !== -1) {
          // Eliminar los archivos del servidor
          const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
          for (const archivo of documento.archivos) {
            await axios.delete(`${baseUrl}/upload/files/${archivo.id}`);
          }

          // Eliminar el documento del array
          this.editedAsset.doc_adicional.splice(index, 1);

          // Actualizar el activo en el servidor
          const updateData = {
            id: this.editedAsset.id,
            doc_adicional: this.editedAsset.doc_adicional,
          };

          await this.$store.dispatch("activos/update", updateData);
          this.asset = {
            ...this.asset,
            doc_adicional: this.editedAsset.doc_adicional,
          };

          this.$notify({
            type: "success",
            message: "Documento eliminado correctamente",
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al eliminar el documento",
        });
        console.error(error);
      }
    },
    async handleDrop(event) {
      this.isDragging = false;
      const files = event.dataTransfer.files;
      await this.handleImageSelect({ target: { files } });
    },
    async handleImageSelect(event) {
      const files = event.target.files;
      const maxSize = 5 * 1024 * 1024; // 5MB limit

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        // Check file type
        if (!file.type.startsWith("image/")) {
          this.$notify({
            type: "warning",
            message: `${file.name} no es una imagen válida.`,
          });
          continue;
        }

        // Check file size
        if (file.size > maxSize) {
          this.$notify({
            type: "warning",
            message: `${file.name} es demasiado grande. El tamaño máximo es 5MB.`,
          });
          continue;
        }

        // Create preview and add to displayed images
        const reader = new FileReader();
        reader.onload = (e) => {
          this.newImages.push(file);
          this.displayedImages.push({
            preview: e.target.result,
            isNew: true,
            file: file,
          });
        };
        reader.readAsDataURL(file);
      }
    },
    removeImage(index) {
      const image = this.displayedImages[index];
      if (image.isNew) {
        // Remove from newImages array if it's a new image
        const fileIndex = this.newImages.findIndex((f) => f === image.file);
        if (fileIndex > -1) {
          this.newImages.splice(fileIndex, 1);
        }
      } else {
        // Add to imagesToDelete array if it's an existing image
        this.imagesToDelete.push(image.id);
      }
      // Remove from displayed images
      this.displayedImages.splice(index, 1);
    },
    async uploadImages() {
      if (this.newImages.length === 0) return;

      try {
        const formData = new FormData();
        this.newImages.forEach((file) => {
          formData.append("files", file);
        });

        // Upload images to server
        const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
        const uploadResponse = await axios.post(`${baseUrl}/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (uploadResponse.data && uploadResponse.data.length > 0) {
          // Add new images to asset's imagenes_adicionales array
          if (!this.editedAsset.imagenes_adicionales) {
            this.editedAsset.imagenes_adicionales = [];
          }
          this.editedAsset.imagenes_adicionales.push(...uploadResponse.data);
        }

        return uploadResponse.data;
      } catch (error) {
        console.error("Error uploading images:", error);
        throw error;
      }
    },
    async removeInstallDoc(docType) {
      try {
        if (!this.asset[docType]?.id) {
          this.$notify({
            type: "warning",
            message: "No hay documento para eliminar",
          });
          return;
        }

        // Delete file from server
        const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
        await axios.delete(`${baseUrl}/upload/files/${this.asset[docType].id}`);

        // Update asset in server with null for this document
        const updateData = {
          id: this.editedAsset.id,
          [docType]: null,
        };

        await this.$store.dispatch("activos/update", updateData);

        // Update local state
        this.editedAsset[docType] = null;
        this.asset = {
          ...this.asset,
          [docType]: null,
        };

        this.$notify({
          type: "success",
          message: "Documento eliminado correctamente",
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al eliminar el documento",
        });
        console.error(error);
      }
    },
    async handleInstallDocUpload(event, docType) {
      const file = event.target.files[0];
      if (!file) return;

      // Validate file type
      if (!file.type.startsWith("image/") && file.type !== "application/pdf") {
        this.$notify({
          type: "warning",
          message: "Solo se permiten archivos PDF o imágenes",
        });
        return;
      }

      try {
        const formData = new FormData();
        formData.append("files", file);

        // Upload file
        const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
        const uploadResponse = await axios.post(`${baseUrl}/upload`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (uploadResponse.data && uploadResponse.data.length > 0) {
          // Update the specific document type in editedAsset
          this.editedAsset[docType] = uploadResponse.data[0];

          // Update the asset in the server
          const updateData = {
            id: this.editedAsset.id,
            [docType]: uploadResponse.data[0],
          };

          await this.$store.dispatch("activos/update", updateData);

          // Update local state
          this.asset = {
            ...this.asset,
            [docType]: uploadResponse.data[0],
          };

          this.$notify({
            type: "success",
            message: "Archivo subido correctamente",
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Error al subir el archivo",
        });
        console.error(error);
      }
    },
  },
};
</script>
<style>
.profile-header {
  background-image: url(/img/theme/profile-cover.jpg);
  background-size: cover;
  background-position: center top;
  min-height: 500px;
}

.dropzone {
  border: 2px dashed #ccc;
  border-radius: 4px;
  padding: 20px;
  text-align: center;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.dropzone-active {
  border-color: #5e72e4;
  background: #eef1fe;
}

.dropzone-content {
  color: #666;
}

.dropzone-content i {
  color: #5e72e4;
}

.dropzone-content p {
  margin: 10px 0;
}

.document-upload-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.document-upload-container .btn-icon-clipboard {
  margin-bottom: 0;
}

.document-upload-container .btn-danger {
  padding: 0.25rem 0.5rem;
}
</style>
